import web from "./web";

export default [...web];
